import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useHistory } from 'react-router-dom'

import { Button, IconButton } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

import { useNavigationContext } from '../../contexts/NavigationContext.jsx'

const Header = ({ className, classes, children, title, actions }) => {
  const { sidebarRetracted, showSidebar } = useNavigationContext()

  const history = useHistory()
  const goToHomepage = () => history.push('/')

  return (
    <div
      className={classnames(
        'st-header-ds',
        className,
        classes.root,
        { 'st-header-ds--retracted': sidebarRetracted },
        { 'st-header-ds--no-sidebar': !showSidebar }
      )}
    >
      <If condition={!showSidebar}>
        <IconButton
          onClick={goToHomepage}
          iconProps={{
            icon: 'sharethisLogo',
            type: 'fill',
            width: '156px',
            height: '32px',
          }}
          className="st-header-ds__margin"
        />
        <span className="st-header-ds__divider" />
      </If>
      {/* Title */}
      <If condition={title}>
        <h1 className={classnames('st-header-ds__title', classes.title)}>{title}</h1>
      </If>

      {/* Custom content */}
      <If condition={children} className={classnames('st-header-ds__children', classes.children)}>
        {children}
      </If>

      {/* Actions */}
      <If condition={actions}>
        <div className={classnames('st-header-ds__actions', classes.actions)}>
          <For each="action" index="index" of={actions}>
            <Button key={index} {...action}>
              {action.children}
            </Button>
          </For>
        </div>
      </If>
    </div>
  )
}

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    logo: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.string,
    actions: PropTypes.string,
  }),
  title: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.array,
}

Header.defaultProps = {
  className: '',
  classes: {
    root: '',
    logo: '',
    title: '',
    children: '',
    actions: '',
  },
  title: '',
  actions: [],
  children: undefined,
}

export default Header
